import React from 'react';
import { Row, Col, Form } from 'reactstrap';
import { AccountFormData } from '../../types/types';
import FormInput from '../common/FormInput';
import SelectInput from '../common/SelectInput';

interface AccountProfileProps {
  formData: AccountFormData;
  setFormData: (data: AccountFormData) => void;
}

const AccountProfile: React.FC<AccountProfileProps> = ({ formData, setFormData }) => {
  const handleInputChange = (field: keyof AccountFormData) => (value: string) => {
    setFormData({ ...formData, [field]: value });
  };

  return (
    <fieldset className="border p-2">
      <legend className="float-none w-auto px-2 mb-0 text-body" style={{ fontSize: '0.9rem' }}>Account Profile</legend>
      <Form>
        <Row>
          <Col md={6}>
            <FormInput
              id="accountId"
              label="Account Id"
              value={formData.accountId}
              onChange={handleInputChange('accountId')}
            />
          </Col>
          <Col md={6}>
            <FormInput
              id="name"
              label="Name"
              value={formData.name}
              onChange={handleInputChange('name')}
              required
            />
          </Col>
          <Col md={6}>
            <FormInput
              id="location"
              label="Location"
              value={formData.location}
              onChange={handleInputChange('location')}
            />
          </Col>
          <Col md={6}>
            <FormInput
              id="tradingName"
              label="Trading Name"
              value={formData.tradingName}
              onChange={handleInputChange('tradingName')}
            />
          </Col>
          <Col md={6}>
            <SelectInput
              formData={formData}
              setFormData={setFormData}
              label="Type"
              id="type"
              options={['Customer', 'Supplier', 'Both', 'Prospect']}
            />
          </Col>
          <Col md={6}>
            <SelectInput
              formData={formData}
              setFormData={setFormData}
              label="Industry"
              id="industry"
              options={['Manufacturing', 'Retail', 'Technology', 'Healthcare', 'Finance', 'Education', 'Other']}
            />
          </Col>
          <Col md={6}>
            <FormInput
              id="acn"
              label="ACN"
              value={formData.acn}
              onChange={handleInputChange('acn')}
            />
          </Col>
          <Col md={6}>
            <FormInput
              id="abn"
              label="ABN"
              value={formData.abn}
              onChange={handleInputChange('abn')}
            />
          </Col>
          <Col md={6}>
            <SelectInput
              formData={formData}
              setFormData={setFormData}
              label="Status"
              id="statusValue"
              options={['Active', 'Inactive', 'Pending', 'Suspended']}
            />
          </Col>
          <Col md={6}>
            <SelectInput
              formData={formData}
              setFormData={setFormData}
              label="Rating"
              id="rating"
              options={['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D', 'F']}
            />
          </Col>
        </Row>
      </Form>
    </fieldset>
  );
};

export default AccountProfile; 